import React, { useState } from "react"
import { graphql, useStaticQuery } from "gatsby"
import Img from "gatsby-image"
import HomeLayout from "../HomeLayout/HomeLayout"
import CoolLightbox from "../LightBox/CoolLightBox"
const Page3 = ({onChange}) => {
  const [isOpen, setOpen] = useState(false)
  const [currentImageIndex, setCurrentIndex] = useState(0)

  const data = useStaticQuery(graphql`
    query {
      Page3: allFile(
        sort: { order: ASC, fields: name }
        filter: { sourceInstanceName: { eq: "EventManagementPage3" } }
      ) {
        nodes {
          id
          name
          childImageSharp {
            fluid {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
      EventManagementInfoPage3: allFile(
        sort: { order: ASC, fields: name }
        filter: { sourceInstanceName: { eq: "EventManagementInfoPage3" } }
      ) {
        nodes {
          id
          name
          childImageSharp {
            fluid {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
    }
  `)

  var images = []
  data.EventManagementInfoPage3.nodes.map(img => {
    var src = img.childImageSharp.fluid.src
    images.push({
      src,
    })
  })

  return (
    <HomeLayout>
        <>
          {data.Page3.nodes.map((img, index) => {
            var idx = index
            if(idx ===3 ||idx===6) return <Img fluid={img.childImageSharp.fluid} />
            if(idx>3) idx--;
            if(index===7) idx=index-2;
            return (
              <div
                onClick={() => {
                  setCurrentIndex(idx)
                  setOpen(true)
                  onChange(false)
                }}
              >
                <Img fluid={img.childImageSharp.fluid} />
              </div>
            )
          })}
          <CoolLightbox
           images={images}
           setCurrentIndex={setCurrentIndex}
           currentImageIndex={currentImageIndex}
           isOpen={isOpen}
           onClose={() => {setOpen(false)
            onChange(true)
          }}
          />
          
        </>
        </HomeLayout>
  )
}
export default Page3
